export default __webpack_public_path__ + "static/media/ciceksepeti.86290187.png";